import React, { useState, useContext } from "react";
import { Container, Form, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import "../../../../../assets/css/customer/subscreens/account/ChangePassword.css";
import BottomNavigation from "../../../../../components/general/bottomnavigation/BottomNavigation";
import AppContext from "../../../../../contexts/AppContext";
import axios from "axios";
import MyNavbar from "../../../../../components/general/mynavbar/MyNavbar";

const ChangePassword = () => {
  const { baseUrl, customerAuthToken } = useContext(AppContext);
  const navigate = useNavigate();
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
    setSuccess("");
  };

  const validatePassword = () => {
    if (
      !formData.currentPassword ||
      !formData.newPassword ||
      !formData.confirmPassword
    ) {
      setError("All fields are required");
      return false;
    }
    if (formData.newPassword.length < 8) {
      setError("New password must be at least 8 characters long");
      return false;
    }
    if (formData.newPassword !== formData.confirmPassword) {
      setError("New password and confirm password do not match");
      return false;
    }
    if (formData.currentPassword === formData.newPassword) {
      setError("New password must be different from current password");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePassword()) return;

    setLoading(true);
    setError("");
    setSuccess("");

    const customer_id = JSON.parse(
      localStorage.getItem("loggedInCustomer"),
    )?.id;
    const formdata = new FormData();
    formdata.append("customer_id", customer_id);
    formdata.append("current_password", formData.currentPassword);
    formdata.append("new_password", formData.newPassword);

    try {
      const response = await axios.post(
        `${baseUrl}/customer/changePassword`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${customerAuthToken}`,
          },
        },
      );
      if (response.data.success) {
        setSuccess("Password changed successfully!");
        setFormData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        setTimeout(() => navigate("/settings"), 2000);
      } else {
        setError(response.data.message || "Something went wrong.");
      }
    } catch (err) {
      setError("Failed to change password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <MyNavbar />
      <div className="change-password-page">
        <Container>
          <div className="password-shell-container">
            <div className="password-header">
              <button
                className="back-btn"
                onClick={() => navigate("/settings")}
              >
                <FaArrowLeft size={20} />
              </button>
              <h1>Change Password</h1>
              <div></div>
            </div>

            {error && (
              <Alert
                variant="danger"
                className="custom-alert"
                onClose={() => setError("")}
                dismissible
              >
                {error}
              </Alert>
            )}

            {success && (
              <Alert
                variant="success"
                className="custom-alert"
                onClose={() => setSuccess("")}
                dismissible
              >
                {success}
              </Alert>
            )}

            <Form onSubmit={handleSubmit} className="password-form">
              <Form.Group className="form-group">
                <Form.Label>Current Password</Form.Label>
                <div className="password-input-wrapper">
                  <Form.Control
                    type={showCurrentPassword ? "text" : "password"}
                    name="currentPassword"
                    value={formData.currentPassword}
                    onChange={handleChange}
                    placeholder="Enter current password"
                    className="password-input"
                  />
                  <button
                    type="button"
                    className="toggle-password-btn"
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                  >
                    {showCurrentPassword ? (
                      <FaEye size={18} />
                    ) : (
                      <FaEyeSlash size={18} />
                    )}
                  </button>
                </div>
              </Form.Group>

              <Form.Group className="form-group">
                <Form.Label>New Password</Form.Label>
                <div className="password-input-wrapper">
                  <Form.Control
                    type={showNewPassword ? "text" : "password"}
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleChange}
                    placeholder="Enter new password"
                    className="password-input"
                  />
                  <button
                    type="button"
                    className="toggle-password-btn"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    {showNewPassword ? (
                      <FaEye size={18} />
                    ) : (
                      <FaEyeSlash size={18} />
                    )}
                  </button>
                </div>
                <Form.Text className="password-hint">
                  Password must be at least 8 characters long
                </Form.Text>
              </Form.Group>

              <Form.Group className="form-group">
                <Form.Label>Confirm New Password</Form.Label>
                <div className="password-input-wrapper">
                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    placeholder="Confirm new password"
                    className="password-input"
                  />
                  <button
                    type="button"
                    className="toggle-password-btn"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? (
                      <FaEye size={18} />
                    ) : (
                      <FaEyeSlash size={18} />
                    )}
                  </button>
                </div>
              </Form.Group>

              <Button type="submit" className="submit-btn" disabled={loading}>
                {loading ? "Changing Password..." : "Change Password"}
              </Button>
            </Form>
          </div>
          <BottomNavigation />
        </Container>
      </div>
    </>
  );
};

export default ChangePassword;
